import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Choreographer } from '../Choreographer';
import { MessageAction, MessageDeliveryStatus, ProductIds } from '../constants';
import { DebugLogger } from '../DebugLogger';
import { Logger } from '../Logger';
import { ChoreographerPlugin } from './ChoreographerPlugin';
export var DUPLICATE_REQUEST_WINDOW = 1000 * 60 * 5; // 5m timeout for duplicate request attempts

export var EngagekitChoreographerPlugin = /*#__PURE__*/function (_ChoreographerPlugin) {
  function EngagekitChoreographerPlugin(env) {
    var metaMetricsData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, EngagekitChoreographerPlugin);
    return _callSuper(this, EngagekitChoreographerPlugin, [ProductIds.ENGAGEKIT, env, metaMetricsData]);
  }

  /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */
  _inherits(EngagekitChoreographerPlugin, _ChoreographerPlugin);
  return _createClass(EngagekitChoreographerPlugin, [{
    key: "shouldLogEvent",
    value: function shouldLogEvent(event) {
      return event.actionSubject !== MessageAction.START || event.action !== MessageDeliveryStatus.BLOCKED;
    }
  }, {
    key: "isValidDuplicateStartRequest",
    value: function isValidDuplicateStartRequest(messageId) {
      var _Choreographer$getIns;
      var currentMessage = (_Choreographer$getIns = Choreographer.getInstance().getCurrentMessage()) !== null && _Choreographer$getIns !== void 0 ? _Choreographer$getIns : Choreographer.getInstance().getCurrentPendingMessage();
      return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < DUPLICATE_REQUEST_WINDOW);
    }
  }, {
    key: "startMessageWithPlugin",
    value: function () {
      var _startMessageWithPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(messageId, callback) {
        var additionalData,
          debugLogger,
          actionSubject,
          isValidDuplicateStartRequest,
          logger,
          didStart,
          result,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              additionalData = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              debugLogger = new DebugLogger(this.state.productId, messageId);
              actionSubject = MessageAction.START;
              debugLogger.trace({
                verbose: "EngagekitChoreographerPlugin::startMessageWithPlugin"
              });

              /**
               * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
               * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
               * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
               * will block the subsequest start request attempt altogether), by checking the Choreographer's
               * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
               * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
               */
              isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
              if (!isValidDuplicateStartRequest) {
                _context.next = 14;
                break;
              }
              logger = new Logger(actionSubject, messageId, _objectSpread(_objectSpread({}, this.state.metaMetricsData), additionalData), this.analyticsClient);
              _context.t0 = Boolean;
              _context.next = 10;
              return callback();
            case 10:
              _context.t1 = _context.sent;
              didStart = (0, _context.t0)(_context.t1);
              if (didStart) {
                logger.started();
                debugLogger.log({
                  verbose: {
                    phase: actionSubject,
                    plugin: this.constructor.name,
                    disposition: MessageDeliveryStatus.STARTED,
                    timestamp: performance.now()
                  }
                });
              }
              return _context.abrupt("return", didStart);
            case 14:
              // Do a just-in-time message start subscription with our callback to stargate
              this.onStart(messageId, callback);

              /**
               * Dispatch the request to start the message, and return the response, which will
               * either be 'started' if successful, and anything else if unsuccessful. Convert
               * that value with a boolean check, because the consumer only cares about true/false.
               */
              _context.next = 17;
              return this.startMessage(messageId, additionalData);
            case 17:
              result = _context.sent;
              return _context.abrupt("return", result === MessageDeliveryStatus.STARTED);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function startMessageWithPlugin(_x, _x2) {
        return _startMessageWithPlugin.apply(this, arguments);
      }
      return startMessageWithPlugin;
    }()
  }, {
    key: "stopMessageWithPlugin",
    value: function () {
      var _stopMessageWithPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(messageId, callback) {
        var additionalData,
          debugLogger,
          result,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              additionalData = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
              debugLogger = new DebugLogger(this.state.productId, messageId);
              debugLogger.trace({
                verbose: "EngagekitChoreographerPlugin::stopMessageWithPlugin"
              });

              // Do a just-in-time message stop subscription with our callback to stargate
              this.onStop(messageId, callback);

              /**
               * Dispatch the request to stop the message, and return the response, which will
               * either be 'stopped' if successful, and anything else if unsuccessful. Convert
               * that value with a boolean check, because the consumer only cares about true/false.
               */
              _context2.next = 6;
              return this.stopMessage(messageId, additionalData);
            case 6:
              result = _context2.sent;
              return _context2.abrupt("return", result === MessageDeliveryStatus.STOPPED);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function stopMessageWithPlugin(_x3, _x4) {
        return _stopMessageWithPlugin.apply(this, arguments);
      }
      return stopMessageWithPlugin;
    }()
  }]);
}(ChoreographerPlugin);